import { render, staticRenderFns } from "./cohort-list.vue?vue&type=template&id=51ddade4&"
import script from "./cohort-list.vue?vue&type=script&lang=js&"
export * from "./cohort-list.vue?vue&type=script&lang=js&"
import style0 from "./cohort-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cohort-list.vue"
export default component.exports